<div class="overflow-x data-table-shadow mat-white-bg desktop-view">
    <ngx-datatable
        *ngIf="isPlatformBrowser"
        class="material"
        [ngClass]="alternativeRowClass"
        [columnMode]="'force'"
        [columns]="columns"
        [count]="datatableModel?.TotalElements"
        [cssClasses]="customClasses"
        [externalPaging]="true"
        [externalSorting]="true"
        [footerHeight]="footerHeight"
        [headerHeight]="headerHeight"
        [messages]="{
            emptyMessage: messages.emptyMessage | translate
        }"
        [limit]="datatableModel?.PageSize"
        [loadingIndicator]="isLoading"
        [offset]="datatableModel?.CurrentPageNumber"
        [reorderable]="reorderable"
        [rowHeight]="'auto'"
        [rows]="datatableModel.Data"
        [rowClass]="datatableModel.rowClass"
        [scrollbarH]="true"
        (sort)="onSort($event)"
        [selected]="selected"
        [selectionType]="selectionType"
        (select)="onSelect($event)"
        [sorts]="sorts"
    >
        <ngx-datatable-footer>
            <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
                let-isVisible="isVisible"
            >
                <div class="page-count" *ngIf="rowCount > 0">
                    {{ offset * pageSize + 1 }}
                    -
                    {{ endIndex }}
                    of
                    {{ rowCount }}
                </div>

                <datatable-pager
                    #ngxDatatablePager
                    [pagerLeftArrowIcon]="'fa fa-chevron-left'"
                    [pagerRightArrowIcon]="'fa fa-chevron-right'"
                    [pagerPreviousIcon]="'fa fa-step-backward'"
                    [pagerNextIcon]="'fa fa-step-forward'"
                    [page]="datatableModel?.CurrentPageNumber + 1"
                    [size]="pageSize"
                    [count]="rowCount"
                    [hidden]="!(rowCount / pageSize > 1)"
                    (change)="loadPage($event)"
                >
                </datatable-pager>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</div>
<ng-template #emptyTemplate let-row="row" let-value="value"></ng-template>
<ng-template #idAnchorEditTemplate let-row="row" let-value="value">
    <a class="btn btn-sm btn-outline-primary">
        <i class="fa fa-pencil" aria-hidden="true"></i>
    </a>
</ng-template>
<ng-template #dateTemplate let-row="row" let-value="value">
    {{ value | date : "dd.MM.yyyy" }}
</ng-template>
<ng-template #dateTimeTemplate let-row="row" let-value="value">
    {{ value | date : "dd.MM.yyyy HH:mm:ss" }}
</ng-template>

<div class="overflow-x data-table-shadow mat-white-bg mobile-view">
    <table
        mat-table
        [dataSource]="datatableModel.Data"
        style="width: 100%"
        *ngIf="datatableModel.Data.length > 0 && displayedColumns.length > 0; else emptyMsg"
    >
        <ng-container [matColumnDef]="$any(column.prop)" *ngFor="let column of columns">
            <th mat-header-cell *matHeaderCellDef>
                <span *ngIf="column.headerTemplate; else defaultHeaderTemplate">
                    <ng-container *ngTemplateOutlet="column.headerTemplate; context: { column: column }"></ng-container>
                </span>
                <ng-template #defaultHeaderTemplate>
                    <span class="app-mat-table-header">
                        {{ column.name | translate | uppercase }}
                    </span>
                </ng-template>
            </th>
            <td mat-cell *matCellDef="let row">
                <span *ngIf="column.cellTemplate; else defaultCellTemplate">
                    <span class="mobile-label" *ngIf="column.name !== ''"
                        >{{ column.name | translate | uppercase }}:</span
                    >
                    <ng-container *ngTemplateOutlet="column.cellTemplate; context: { row: row }"> </ng-container>
                </span>
                <ng-template #defaultCellTemplate>
                    <span class="mobile-label">{{ column.name | translate | uppercase }}:</span>
                    <span>
                        {{ row[column.prop] }}
                    </span>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="onSelectMbl(row)"></tr>
    </table>
    <div class="mobile-screen-paginator">
        <mat-paginator
            [length]="datatableModel?.TotalElements"
            [pageIndex]="datatableModel?.CurrentPageNumber"
            [pageSize]="datatableModel?.PageSize"
            showFirstLastButtons
            (page)="loadPageForMobile($event)"
        ></mat-paginator>
        <span class="total-count" *ngIf="mobileScreenPaginatorTotalCount"
            >{{ datatableModel?.TotalElements }} {{ "TOTAL" | translate }}</span
        >
    </div>

    <ng-template #emptyMsg>
        <span>{{ messages.emptyMessage | translate }}</span>
    </ng-template>
</div>
